import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {v4 as uuidv4} from 'uuid'
import {
    MdArrowCircleDown,
    MdBolt,
    MdContentCopy,
    MdDelete,
    MdEdit,
} from 'react-icons/md'
import ButtonWithIcon from '../../../../common/ButtonWithIcon'

import {handleDownloadRaport} from '../../../../utils/handlers/index.js'
import {Input} from "../../../../common/inputs";
import qs from 'qs'
import {SimpleTable} from "../../../../common/simpleTable/SimpleTable.jsx";
import {HeaderTitle} from "../../../../common/HeaderTitle.jsx";
import {useRaporty} from "../../../../../api/domain/raporty/queries/useRaporty.jsx";
import {listaRaportowColumns} from "../../lib/columns/listaRaportowColumns.js";
import {Icons} from "../../../../common/Icons.jsx";
import {ModalDeleteRaport, ModalGenerujRaport} from "../../lib/modals.jsx";
import {useNavigate} from "react-router-dom";
import {LinkContainer} from "react-router-bootstrap";
import Api from "../../../../../api/api.js";
import {useKlonujRaport} from "../../../../../api/domain/raporty/mutations/useKlonujRaport.jsx";
import {useStatusRaportu} from "../../../../../api/domain/raporty/queries/useStatusRaportu.jsx";

const ViewRaportyList = () => {
    const TIMEOUT_CHECK_IS_READY = 6000
    const navigate = useNavigate()

    const [params, setParams] = useState([])
    const [parametry, setParametry] = useState([])
    const [uuid, setUuid] = useState('')
    const [ready, setReady] = useState('')
    const [isChecking, setIsChecking] = useState(false)
    const [showModalGeneruj, setShowModalGeneruj] = useState(false)
    const [showModalDelete, setShowModalDelete] = useState(false)
    const [previewMode, setPreviewMode] = useState('')
    const [raport, setRaport] = useState(null)
    const [loading, setLoading] = useState(null)
    // const [showHistory, setShowHistory] = useState(false)
    const permissions = useSelector((state) => state.user.permissions)
    const canModifyReports = Array.isArray(permissions) && permissions.includes('raporty_modyfikacja')
    const canViewReports = Array.isArray(permissions) && permissions.includes('raporty_podglad')

    const raporty = useRaporty()
    const klonuj = useKlonujRaport()
    const {data: raportStatus} = useStatusRaportu(uuid, isChecking)


    const downloadRaport = () => {
        setRaport(null)
        setReady('')
        handleDownloadRaport(uuid, setLoading, 'oper/raporty/download')
    }

    const prepareParams = (raport) => {
        const raportFlat = {
            raport_id: raport?.id,
            key: previewMode,
            uuid,
        }
        const raportFlatStr = qs.stringify(raportFlat)
        const parametryStr = JSON.stringify(parametry) || '[]'
        return parametry?.length > 0 ? `?${raportFlatStr}&parametry=${parametryStr}` : `?${raportFlatStr}`

    }

    const generujRaport = () => {
        return Api(`oper/raporty/generuj-raport${prepareParams(raport)}`).then(() => {
                setIsChecking(true)
            }
        )
    }


    const handleAction = (raport, state, action = 'gen') => {
        setRaport(raport)
        if (action === 'del') {
            setShowModalDelete(state)
        } else if (action === 'preview') {
            setPreviewMode(action)
            setUuid(uuidv4())
            setShowModalGeneruj(state)
        } else if (action === 'gen') {
            setPreviewMode('gen')
            setUuid(uuidv4())
            setShowModalGeneruj(state)
        }
    }

    // const handleShowHistory = (raport) => {
    //     setRaport(raport)
    //     setShowHistory(true)
    // }


    const addTd = (row) => {

        const allow = {
            show: {
                generuj: canViewReports,
                edit: canModifyReports,
                preview: canViewReports
            },
            disable: {
                generuj: false,
                edit: false
            }
        }

        return (
            <td>
                <div className={'d-flex gap-1 justify-content-end'}>
                    {canViewReports && ready === row.id && (
                        <ButtonWithIcon
                            size={'sm'}

                            variant={'success'}
                            onClick={() => downloadRaport()}
                            title={'pobierz raport'}
                            icon={<MdArrowCircleDown/>}
                        />
                    )}
                    <>
                        {allow.show.generuj &&

                            <ButtonWithIcon
                                size={'sm'}
                                disabled={allow.disable.generuj}
                                onClick={() => handleAction(row, true, 'gen')}
                                title={'generuj raport'}
                                icon={<MdBolt/>}
                            />
                        }
                        {/*{allow.show.preview ? <ButtonWithIcon*/}
                        {/*    size={'sm'}*/}
                        {/*    onClick={() => handleAction(row, true, 'preview')}*/}
                        {/*    title={'podejrzyj zawartość'}*/}
                        {/*    icon={<MdPreview/>}*/}
                        {/*/> : null}*/}
                    </>

                    {allow.show.edit && (<>
                        <ButtonWithIcon
                            size={'sm'}
                            disabled={allow.disable.edit}
                            title={'edytuj raport'}
                            onClick={() => navigate(`/oper/raporty/${row?.id}`)}
                            icon={<MdEdit/>}
                        />

                        <ButtonWithIcon
                            size={'sm'}
                            disabled={allow.disable.edit}
                            title={'klonuj raport'}
                            onClick={() => klonuj.mutate(row?.id)}
                            icon={<MdContentCopy/>}
                        />

                        {/*<ButtonWithIcon*/}
                        {/*    variant={'secondary'}*/}
                        {/*    size={'sm'}*/}
                        {/*    title={'historia raportu'}*/}
                        {/*    onClick={() => handleShowHistory(row?.id)}*/}
                        {/*    icon={<MdHistory/>}*/}
                        {/*/>*/}

                        <ButtonWithIcon
                            disabled={allow.disable.edit}
                            size={'sm'}
                            variant={'danger'}
                            onClick={() => handleAction(row, true, 'del')}
                            title={'usuń raport'}
                            icon={<MdDelete/>}
                        />
                    </>)}
                </div>
            </td>
        )
    }


    const setParamsState = (index, field, value) => {
        setParams(prev => [...Object.entries({...prev, [index]: {...prev[index], [field]: value}}).map(e => e[1])])
    }

    const paramsForm = params?.length > 0 ?
        <><h5 className={'mt-4'}>Wypełnij parametry</h5>
            {params?.map((param, index) => {
                return <div className={'mt-3'} key={index}>
                    <Input key={index}
                           label={`Nazwa parametru: ${param.nazwa}`}
                           onChange={(e) => setParamsState(index, 'wartosc', e.target.value)}
                           value={param.wartosc || ''}/>
                    <Input
                        onChange={() => null}
                        key={index}
                        label={'Opis parametru'}
                        disabled
                        value={param.opis || ''}
                    />
                </div>
            })}
        </>
        : <>''</>


    useEffect(() => {
        let timer
        if (isChecking) {
            timer = setTimeout(() => {
                setIsChecking(false)
            }, TIMEOUT_CHECK_IS_READY);
        }
        return () => clearTimeout(timer);

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (raportStatus?.status === 'success') {
            setReady(raport?.id)
            setIsChecking(false)

        }
        // eslint-disable-next-line
    }, [raportStatus])


    useEffect(() => {
        setParams(raporty?.data?.find(r => r.id === raport?.id)?.parametry)
        // eslint-disable-next-line
    }, [raport?.id])


    useEffect(() => {
        setParametry(params?.map((p) => ({...p, value: {[p.nazwa]: p.wartosc}})))
    }, [params])



    const modals = () => <>
        <ModalDeleteRaport
            currPozycja={raport}
            show={showModalDelete}
            handleClose={() => setShowModalDelete(false)}
        />

        <ModalGenerujRaport
            currPozycja={raport}
            paramsForm={paramsForm}
            show={showModalGeneruj}
            setParametry={setParametry}
            setIsChecking={setIsChecking}
            query={prepareParams(raport)}
            handleAction={generujRaport}
            handleClose={() => setShowModalGeneruj(false)}
        />
    </>

    return (
        <>
            <HeaderTitle
                breadcrumbLinks={[
                    {
                        label: 'Strona główna',
                        to: '/',
                    },
                    {label: 'Wszytkie raporty'},
                ]}
                size={'fs-3'}
                nav
                destination={'/'}
                title={'Lista raportów'}/>
            {modals(raporty.refetch)}

            {canModifyReports && (
                <div className={'d-flex justify-content-end'}>
                    <LinkContainer to={'/oper/raporty/nowy'}>
                        <ButtonWithIcon
                            text={'Dodaj raport'}
                            variant={'primary'}
                            icon={<Icons.add/>}
                            title='Dodaj raport'/>
                    </LinkContainer>
                </div>
            )}

            <SimpleTable
                columns={listaRaportowColumns}
                addTh={() => <th>Operacje</th>}
                addTd={addTd}
                data={raporty.data}

            />
        </>
    )
}

export default ViewRaportyList